import { BarChartOut } from "@/api";

export type UsageUnit = BarChartOut["unit"];

export const formatValue = (value: number, unit: UsageUnit | null | undefined) => {
    if (unit === "count" || !unit) return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(value);
    // Single messages cost fractions of a cent; two decimals would show them as zero.
    const small = value !== 0 && Math.abs(value) < 1;
    return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: unit.toUpperCase(),
        ...(small ? { maximumSignificantDigits: 3 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    }).format(value);
};
